<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <br><br><br><br><br><br>
  <main class="mt-0 main-content">
    <div class="py-4 container-fluid">
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <i class="ni ni-album-2 text-dark text-sm opacity-10"></i>
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">Loan</h5>

                <p class="mb-0 font-weight-bold text-sm"></p>
              </div>
            </div>
            <div
              class="mx-auto mt-3 col-lg-4 col-md-6 my-sm-auto ms-sm-auto me-sm-0"
            >
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                >

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <form id="form" role="form" method="POST">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">{{message}}</p>
                <argon-button color="success" size="sm" class="ms-auto" @click.prevent="submitData()"
                  >Save</argon-button
                >
                <router-view></router-view>
              </div>
            </div>
            <div class="card-body">
              
              <div class="row">

                <div class="col-md-6">
                  <label for="name" class="form-control-label"
                    >Name
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="name" name="name" type="text" :value="elements[0].name"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="agent_npn" class="form-control-label"
                    >Agent NPN
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="agent_npn" name="agent_npn" type="text" :value="elements[0].agent_npn"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="agent_type" class="form-control-label"
                    >Agent Type
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="agent_type" name="agent_type" type="text" :value="elements[0].agent_type"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="agent" class="form-control-label"
                    >Amount
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="amount" name="amount" type="text" :value="elements[0].amount"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="payment_date" class="form-control-label"
                    >Loan Date
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="loan_date" name="loan_date" type="date" :value="elements[0].loan_date"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="payment_method" class="form-control-label"
                    >Payment Method
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="payment_method" name="payment_method" type="text" :value="elements[0].payment_method"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="fym_point_person" class="form-control-label"
                    >FYM Point Person
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="fym_point_person" name="fym_point_person" type="text" :value="elements[0].fym_point_person"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="notes" class="form-control-label"
                    >Reason
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="reason" name="reason" type="text" :value="elements[0].reason"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="qb" class="form-control-label"
                    >QB
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="qb" name="qb" type="text" :value="elements[0].qb"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="account" class="form-control-label"
                    >Account
                  </label><br>
                  <span>
                    <input class="form-control form-control-default invalid" id="account" name="account" type="text" :value="elements[0].account"/>
                  </span>
                </div>

                <div class="col-md-6">
                  <label for="loan_type" class="form-control-label"
                    >Loan Type</label
                  >
                  <span>
                    <select id="loan_type" name="loan_type" class="form-select" :value="selectedLoanType">
                      <option v-for="element in loan_types" :value="element.id" :key="element.id">
                        {{ element.name }}
                      </option>
                    </select>
                  </span>
                </div>

              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import router from "@/router";
import setTooltip from "@/assets/js/tooltip.js";
import Navbar from "@/examples/PageLayout/NavbarLoggedin.vue";
import ArgonButton from "@/components/ArgonButton.vue";

var message = "Loan";
var selectedPaymentOption;

export default {
  name: "Loan",
  props: ['id'],
  data() {
    return {
      showMenu: false,
      elements: [{id:0}],
      message,
      payment_options: [],
      selectedPaymentOption,
      loan_types: [],
      selectedLoanType: 1
    }
  },
  computed: {
    formattedDate(dt) {
      return new Date(dt).toLocaleDateString();
    },
    isFYMAdmin() {
      return this.role === 'FYM Admin';
    },
    isAgencyAdmin() {
      return this.role === 'Agency Admin';
    },
    isAgentManager() {
      return this.role === 'Agent Manager';
    },
    isAgent() {
      return this.role === 'Agent';
    }
  },
  methods: {
    serializeForm(){
      
      let myForm = document.getElementById('form'); 
      let formData = new FormData(myForm);
      const data = {}; 
      // need to convert it before using not with XMLHttpRequest
      for (let [key, val] of formData.entries()) {
            Object.assign(data, {[key]: val})
      }
      return(data);
    },
    async checkAuth() {
      let response = await fetch("/apis/auth");
      this.loggedin = await response.json();
      if(this.loggedin =="notloggedin") {
        location.href="/home";
      }
    },
    async getData() {
        let response = await fetch("/apis/element_load/at_loans/" + this.$route.params.id);
        this.elements = await response.json(); 
        this.selectedPaymentOption = this.elements[0].payment_option_id;
    },
    async getLookups() {

      let response = await fetch('/apis/get_lu/payment_options');
      this.payment_options = await response.json();

      let response2 = await fetch('/apis/get_lu/loan_types');
      this.loan_types = await response2.json();

    },
    submitData: function() {
      
      var action = 'create';
      var api = 'Loan_create';
      var element_id = this.$route.params.id;

      if (element_id > 0) {
        action = 'update';
        api = 'Loan_update/' + element_id;
      }

      fetch('/apis/' + api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this.serializeForm()),
     })
     
      .then((res) => res.json())
      .then((data) => {
        if (data.result === 'Loan_' + action + 'd') {          
          this.message = data.message;
          this.getData();
        }
        else {
          router.push('/');
        }
      })
      .catch((err) => console.log(err));
    },
  },
  components: { Navbar,  ArgonButton },
  created() {

    this.checkAuth();

    if (this.$route.params.id > 0) {
      this.getData();
    }
    else {
      this.elements[0].id = "0";
    }

    this.getLookups();
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = false;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
  }
  
};
</script>